import { render, staticRenderFns } from "./item.vue?vue&type=template&id=1e36e09b&scoped=true&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"
import style0 from "./item.vue?vue&type=style&index=0&id=1e36e09b&prod&lang=scss&"
import style1 from "./item.vue?vue&type=style&index=1&id=1e36e09b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e36e09b",
  null
  
)

export default component.exports